// This file is generate automatically by NPM// Don't edit this fileimport {AutoCarousel} from '../../../templates/flexibles/auto-carousel/auto-carousel.js'
import {Banner} from '../../../templates/flexibles/banner/banner.js'
import {BigSubmenu} from '../../../templates/flexibles/big-submenu/big-submenu.js'
import {Calculator} from '../../../templates/flexibles/calculator/calculator.js'
import {CgvCategories} from '../../../templates/flexibles/cgv-categories/cgv-categories.js'
import {FeaturesFolders} from '../../../templates/flexibles/features-folders/features-folders.js'
import {Header} from '../../../templates/flexibles/header/header.js'
import {HeaderCards} from '../../../templates/flexibles/header-cards/header-cards.js'
import {InteractiveMap} from '../../../templates/flexibles/interactive-map/interactive-map.js'
import {PlotPricing} from '../../../templates/flexibles/plot-pricing/plot-pricing.js'
import {PostsList} from '../../../templates/flexibles/posts-list/posts-list.js'
import {ProductArguments} from '../../../templates/flexibles/product-arguments/product-arguments.js'
import {ProductFeatures} from '../../../templates/flexibles/product-features/product-features.js'
import {SolutionProducts} from '../../../templates/flexibles/solution-products/solution-products.js'
import {SubmenuNavigation} from '../../../templates/flexibles/submenu-navigation/submenu-navigation.js'
import {TableOffer} from '../../../templates/flexibles/table-offer/table-offer.js'
import {TimelineContent} from '../../../templates/flexibles/timeline-content/timeline-content.js'

export let flexiblesController = {
  AutoCarousel: AutoCarousel,
  Banner: Banner,
  BigSubmenu: BigSubmenu,
  Calculator: Calculator,
  CgvCategories: CgvCategories,
  FeaturesFolders: FeaturesFolders,
  Header: Header,
  HeaderCards: HeaderCards,
  InteractiveMap: InteractiveMap,
  PlotPricing: PlotPricing,
  PostsList: PostsList,
  ProductArguments: ProductArguments,
  ProductFeatures: ProductFeatures,
  SolutionProducts: SolutionProducts,
  SubmenuNavigation: SubmenuNavigation,
  TableOffer: TableOffer,
  TimelineContent: TimelineContent
}